import React from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { iPromo, iTicketingSetup } from 'services/Ticketing/Ticketing.type';
import { card, formatDay, formatMoney, sectionTitle } from '../common';

interface PromoCodesSectionProps {
  data: iTicketingSetup;
  setPromo: (promo: Partial<iPromo> | null) => void;
}

export function PromoCodesSection({
  data,
  setPromo,
}: PromoCodesSectionProps): JSX.Element {
  const s = data.settings;

  return (
    <Box sx={{ ...card }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography sx={sectionTitle}>Codes promo</Typography>
        <Button
          size="small"
          variant="outlined"
          sx={{ textTransform: 'none', borderColor: '#ddd', color: '#111' }}
          onClick={() =>
            setPromo({
              code: '',
              kind: 'percent',
              value: 10,
              max_uses: null,
              valid_until: null,
              ticket_type_ids: [],
              is_active: true,
            })
          }
        >
          + Nouveau code
        </Button>
      </Box>

      {data.promo_codes.length === 0 ? (
        <Typography sx={{ fontSize: 14, color: '#888' }}>
          Aucun code.
        </Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Réduction</TableCell>
              <TableCell>Utilisations</TableCell>
              <TableCell>Jusqu&apos;au</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.promo_codes.map((p) => (
              <TableRow key={p.id} sx={{ opacity: p.is_active ? 1 : 0.5 }}>
                <TableCell sx={{ fontFamily: 'monospace' }}>{p.code}</TableCell>
                <TableCell>
                  {p.kind === 'percent'
                    ? `${p.value} %`
                    : formatMoney(p.value, s.currency)}
                </TableCell>
                <TableCell>
                  {p.used_count}
                  {p.max_uses ? ` / ${p.max_uses}` : ''}
                </TableCell>
                <TableCell>
                  {p.valid_until ? formatDay(p.valid_until) : '—'}
                </TableCell>
                <TableCell align="right">
                  <Button
                    size="small"
                    sx={{ textTransform: 'none' }}
                    onClick={() => setPromo(p)}
                  >
                    Modifier
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}

export default PromoCodesSection;
